import styled from 'styled-components';

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const FormFieldInline = styled(FormField)`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: ${(props) => props.columns || '100%'};
  width: 100%;
`;

export const ProductIdMessage = styled.div`
  margin-top: 6px;
  font-size: 12px;
`;

export const LTIOptionContainer = styled.div`
`;

export const LTIKeyMessage = styled.div`
  margin-left: 35px;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 600;
`;
